__turbopack_context__.v({
  "blocker": "dQdNja_blocker",
});
